import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProductPage = () => {
  const diamondShapes = [
  {
    name: 'ROUND',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/ROUND.png'
  },
  {
    name: 'PEAR',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/pear.png'
  },
  {
    name: 'CUSHION',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/Cushion.png'
  },
  {
    name: 'BAGUETTE',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/Baguette-1.png'
  },
  {
    name: 'EMERALD',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/Emerald-1.png'
  },
  {
    name: 'RADIANT',
    image: 'http://gurudiam.com/wp-content/uploads/2024/05/image-76.png'
  },
  {
    name: 'HEART',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/Heart-1.png'
  },
  {
    name: 'ASSCHER',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/ASSCHER.png'
  },
  {
    name: 'MARQUISE',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/Marquise.png'
  },
  {
    name: 'OVAL',
    image: 'http://gurudiam.com/wp-content/uploads/2024/07/OVAL.png'
  }];


  const specifications = [
  'Certified lab-grown diamonds',
  'Available in D-J color grades',
  'IF to SI clarity ranges',
  '0.30ct to 10ct+ sizes',
  'All major certifications (GIA, IGI, GCAL)',
  'Consistent quality assurance',
  'Stable pricing and supply',
  'Bulk order capability'];


  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <Navbar />

      {/* Hero Section */}
      <section className="section-padding bg-[var(--bg-secondary)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="hero-large mb-6">Our Diamond Collection</h1>
            <p className="body-large">
              Exquisite lab-grown diamonds in every shape, size, and quality grade
            </p>
          </div>
        </div>
      </section>

      {/* Diamond Shapes Section - GuruDiam Style */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="hero-medium mb-4">Shop By Shape</h2>
            <p className="body-large">Select from our exquisite collection of diamond cuts</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {diamondShapes.map((shape, index) =>
            <div
              key={index}
              className="group cursor-pointer">

                <div className="bg-[var(--bg-secondary)] p-8 transition-all hover:bg-[var(--accent-green-pale)] hover:shadow-lg">
                  <img
                  src={shape.image}
                  alt={shape.name}
                  className="w-full h-32 object-contain mb-4 transition-transform group-hover:scale-110" />

                  <h3 className="heading-3 text-center">{shape.name}</h3>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Diamond Categories Section - GuruDiam Style */}
      <section className="section-padding-small bg-[var(--bg-secondary)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="hero-medium mb-4">Our Diamond Categories</h2>
            <p className="body-large">Explore our comprehensive collection of lab-grown diamonds</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Certified Diamonds */}
            <Link to="/certified-diamonds" className="bg-white p-8 hover-lift cursor-pointer group">
              <div className="h-48 mb-6 flex items-center justify-center bg-[var(--bg-secondary)] overflow-hidden">
                <img
                  src="http://gurudiam.com/wp-content/uploads/2024/07/ROUND.png"
                  alt="Certified Diamonds"
                  className="h-32 w-auto object-contain transition-transform group-hover:scale-110" />

              </div>
              <h3 className="heading-2 mb-3">CERTIFIED DIAMONDS</h3>
              <p className="body-regular mb-4">Premium certified lab-grown diamonds with IGI, GIA certification</p>
            </Link>

            {/* Melee Diamonds */}
            <Link to="/melee-diamonds" className="bg-white p-8 hover-lift cursor-pointer group">
              <div className="h-48 mb-6 flex items-center justify-center bg-[var(--bg-secondary)] overflow-hidden">
                <img
                  src="http://gurudiam.com/wp-content/uploads/2024/07/pear.png"
                  alt="Melee Diamonds"
                  className="h-32 w-auto object-contain transition-transform group-hover:scale-110" />

              </div>
              <h3 className="heading-2 mb-3">MELEE DIAMONDS</h3>
              <p className="body-regular mb-4">Small diamonds perfect for accent stones and intricate designs</p>
            </Link>

            {/* Fancy Cut Diamonds */}
            <Link to="/fancy-cut-diamonds" className="bg-white p-8 hover-lift cursor-pointer group">
              <div className="h-48 mb-6 flex items-center justify-center bg-[var(--bg-secondary)] overflow-hidden">
                <img
                  src="http://gurudiam.com/wp-content/uploads/2024/07/Heart-1.png"
                  alt="Fancy Cut Diamonds"
                  className="h-32 w-auto object-contain transition-transform group-hover:scale-110" />

              </div>
              <h3 className="heading-2 mb-3">FANCY CUT DIAMONDS</h3>
              <p className="body-regular mb-4">Unique and rare cuts including heart, marquise, and pear shapes</p>
            </Link>

            {/* Fancy Color Diamonds */}
            <Link to="/fancy-color-diamonds" className="bg-white p-8 hover-lift cursor-pointer group">
              <div className="h-48 mb-6 flex items-center justify-center bg-[var(--bg-secondary)] overflow-hidden">
                <img
                  src="http://gurudiam.com/wp-content/uploads/2024/07/Cushion.png"
                  alt="Fancy Color Diamonds"
                  className="h-32 w-auto object-contain transition-transform group-hover:scale-110" />

              </div>
              <h3 className="heading-2 mb-3">FANCY COLOR DIAMONDS</h3>
              <p className="body-regular mb-4">Stunning colored diamonds in pink, blue, yellow, and more</p>
            </Link>

            {/* Matching Pair Diamonds */}
            <Link to="/matching-pair-diamonds" className="bg-white p-8 hover-lift cursor-pointer group">
              <div className="h-48 mb-6 flex items-center justify-center bg-[var(--bg-secondary)] overflow-hidden">
                <img
                  src="http://gurudiam.com/wp-content/uploads/2024/07/OVAL.png"
                  alt="Matching Pair Diamonds"
                  className="h-32 w-auto object-contain transition-transform group-hover:scale-110" />

              </div>
              <h3 className="heading-2 mb-3">MATCHING PAIR DIAMONDS</h3>
              <p className="body-regular mb-4">Perfectly matched pairs for earrings and symmetrical designs</p>
            </Link>

            {/* Antique Cuts */}
            <Link to="/certified-diamonds" className="bg-white p-8 hover-lift cursor-pointer group">
              <div className="h-48 mb-6 flex items-center justify-center bg-[var(--bg-secondary)] overflow-hidden">
                <img
                  src="http://gurudiam.com/wp-content/uploads/2024/07/ASSCHER.png"
                  alt="Antique Cuts"
                  className="h-32 w-auto object-contain transition-transform group-hover:scale-110" />

              </div>
              <h3 className="heading-2 mb-3">ANTIQUE CUTS</h3>
              <p className="body-regular mb-4">Vintage-inspired cuts with timeless elegance and character</p>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Partner With Us Section */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="hero-medium mb-6">Why Partner With Us?</h2>
              <p className="body-large mb-8">
                We offer a comprehensive range of lab-grown diamonds to meet every need of retailers and jewellers.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {specifications.map((spec, index) =>
                <div key={index} className="flex items-start gap-3">
                    <CheckCircle size={20} className="text-[var(--accent-green-medium)] flex-shrink-0 mt-1" />
                    <span className="body-regular">{spec}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="bg-[var(--accent-green-dark)] text-white p-12">
              <h3 className="heading-2 mb-6 !text-[#FFFFFF]">Our Commitment</h3>
              <ul className="space-y-4">
                <li className="body-regular text-white flex items-start gap-3">
                  <span className="text-2xl">•</span>
                  <span>Customer First Approach for lasting partnerships</span>
                </li>
                <li className="body-regular text-white flex items-start gap-3">
                  <span className="text-2xl">•</span>
                  <span>Consistent Assortment in every parcel</span>
                </li>
                <li className="body-regular text-white flex items-start gap-3">
                  <span className="text-2xl">•</span>
                  <span>Stable Supply ensuring business continuity</span>
                </li>
                <li className="body-regular text-white flex items-start gap-3">
                  <span className="text-2xl">•</span>
                  <span>Best Value in total cost of ownership</span>
                </li>
              </ul>
              <div className="mt-8 pt-8 border-t border-white border-opacity-20">
                <p className="heading-3 !text-[#FFFFFF]" style={{ letterSpacing: '2px' }}>REAL • PURE • BETTER</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Environmental Benefits */}
      <section className="section-padding">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="hero-medium mb-4">Environmental Impact</h2>
            <p className="body-large">Every carat makes a difference</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-[var(--accent-green-pale)]">
              <div className="heading-1 text-[var(--accent-green-dark)] mb-4" style={{ fontSize: '48px' }}>
                200-250
              </div>
              <p className="heading-3 mb-2">Tonnes Saved</p>
              <p className="body-regular">Land extraction/destruction prevented per carat</p>
            </div>
            <div className="text-center p-8 bg-[var(--accent-green-pale)]">
              <div className="heading-1 text-[var(--accent-green-dark)] mb-4" style={{ fontSize: '48px' }}>
                109
              </div>
              <p className="heading-3 mb-2">Gallons Saved</p>
              <p className="body-regular">Water conservation per carat produced</p>
            </div>
            <div className="text-center p-8 bg-[var(--accent-green-pale)]">
              <div className="heading-1 text-[var(--accent-green-dark)] mb-4" style={{ fontSize: '48px' }}>
                100%
              </div>
              <p className="heading-3 mb-2">Conflict Free</p>
              <p className="body-regular">TRUE ethical diamonds, protecting human rights</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>);

};

export default ProductPage;